import { useEffect, useState } from 'react';
import styled from '@emotion/styled';

const StyledVideo = styled.video`
  cursor: pointer;
  width: 100%;
  height: 100%;
  z-index: auto;
  object-fit: cover;
`;

interface VideoPlayerProps {
  src: VideoResponse | File | null;
}

function VideoPlayer({ src }: VideoPlayerProps) {
  const [videoPreview, setVideoPreview] = useState<string | undefined>();

  useEffect(() => {
    if (!src) {
      setVideoPreview(undefined);
      return;
    }

    if (src instanceof File) {
      setVideoPreview(URL.createObjectURL(src));
      return;
    }

    setVideoPreview(src.url ?? undefined);
  }, [src]);

  return <StyledVideo src={videoPreview} loop autoPlay controls />;
}

export default VideoPlayer;
